import React from "react";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export default function Login() {
  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/api/auth/google/login/`;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 24px",
        textAlign: "center",
      }}
    >
      {/* Checkmark logo — trust + verified feel for sign-in */}
      <img
        src="/vhn-logo-check.svg"
        alt="Vehicle History Now"
        height="52"
        style={{ marginBottom: "20px" }}
      />
      <h2 style={{ margin: "0 0 8px", fontSize: "22px", fontWeight: 700, color: "#0d2137" }}>
        Sign In to Your Account
      </h2>
      <p style={{ margin: "0 0 24px", fontSize: "15px", color: "#555" }}>
        Sign in with Google to access all your past reports in one place.
      </p>

      <button
        onClick={handleGoogleLogin}
        style={{
          backgroundColor: "#fff",
          color: "#3c4043",
          border: "1px solid #dadce0",
          padding: "10px 24px",
          borderRadius: "6px",
          fontSize: "15px",
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          transition: "box-shadow 0.15s",
        }}
        onMouseOver={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.18)")}
        onMouseOut={(e) => (e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)")}
      >
        <img
          src="https://developers.google.com/identity/images/g-logo.png"
          alt="Google logo"
          width="20"
          height="20"
        />
        Continue with Google
      </button>

      <p style={{ marginTop: "14px", fontSize: "13px", color: "#999" }}>
        You’ll be redirected to Google’s secure sign-in page.
      </p>
    </div>
  );
}
